module.exports = "/_next/static/images/3e460a59560c3403dd53ab247538b384-cardMoradita.svg";